import { Paper, PaperProps, styled } from '@mui/material';

interface CustomProps {
  isBlurred?: boolean;
}

export const ListItemCard = styled(Paper)<PaperProps & CustomProps>(
  ({ theme, isBlurred }) => ({
    padding: 16,
    display: 'flex',
    gap: 2,
    position: 'relative',
    height: '100%',
    flexDirection: 'column',
    '& p, & h6, & img': {
      filter: isBlurred ? 'blur(4px)' : 'none',
    },
  })
);
